<template>
  <div class="mb-5 flex basis-full items-stretch lg:mb-0 lg:basis-4/12">
    <div class="rounded bg-white px-5 py-4 shadow">
      <img
        class="mx-auto mb-4 w-full"
        src="~/assets/images/Te/TeCommon/MentorSupport/ChatSupport/ill-mentor-support-chat.svg"
        alt="チャットサポート"
        width="339"
        height="191"
        loading="lazy"
      >
      <h2 class="co-display-10 mb-2 text-center font-bold">
        <slot name="title">
          毎日の
        </slot>
        <br>
        チャットサポート
      </h2>
      <p class="mb-0">
        <slot name="lead">
          メンターが毎日オンラインで待機してるので疑問点を聞けば遅くとも24時間以内にチャットで回答がもらえます。
        </slot>
      </p>
      <slot name="annotation" />
    </div>
  </div>
</template>
